import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { env } from '@/config/env'
import { configureAmplify } from '@/lib/amplify'
import { initSentry } from '@/lib/sentry'
import { syncConsentOnStartup } from '@/lib/analytics'
import { useConsentStore } from '@/features/consent/consentStore'
import { AppProviders } from '@/providers/AppProviders'
import { AppRoutes } from '@/routes/AppRoutes'
import { DomainRedirect } from '@/routes/DomainRedirect'

const root = createRoot(document.getElementById('root')!)

// Migrazione dominio: sul vecchio dominio (VITE_REDIRECT_TO valorizzato) non
// avviamo l'app — mostriamo la pagina-ponte che reindirizza al nuovo dominio.
// Intercettato qui, prima di Amplify/router, così il vecchio dominio resta leggero.
if (env.redirectTo) {
  root.render(
    <StrictMode>
      <DomainRedirect target={env.redirectTo} />
    </StrictMode>,
  )
} else {
  initSentry()
  configureAmplify()

  // Riapplica al reload il consenso analytics già scelto (Consent Mode + GA).
  {
    const { decided, analytics } = useConsentStore.getState()
    syncConsentOnStartup(decided, analytics)
  }

  root.render(
    <StrictMode>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </StrictMode>,
  )
}
